'use client';

import { SvgChevronright } from '@common/icon';
import { useSuspenseQuery } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { AuthQueryOptions } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { ROUTES } from '@/constants';

const Card = ({
  href,
  label,
  count,
  badge,
}: {
  href: string;
  label: string;
  count: ReactNode;
  badge?: ReactNode;
}) => (
  <CustomLink
    href={href}
    className="group flex flex-1 items-center justify-between gap-2 rounded-large bg-Gray-white px-20 py-16 shadow-sm transition-all duration-200 hover:-translate-y-1 active:translate-y-0 mobile-sm:gap-0"
  >
    <div className="flex flex-1 items-center mobile-sm:flex-col mobile-sm:items-start mobile-sm:gap-2">
      <p className="flex-1 font-600 text-Gray-600 typo-caption1">{label}</p>
      <div className="flex items-center gap-4 mobile-sm:-mt-2">
        <p className="flex gap-4 font-700 text-Gray-900 typo-h7">{count}</p>
        {badge}
      </div>
    </div>
    <SvgChevronright className="size-16 shrink-0 text-Gray-500 transition-all duration-200 group-hover:translate-x-4 group-hover:text-Gray-900" />
  </CustomLink>
);

export const PersonalizedSection = () => {
  const { data: policyData } = useSuspenseQuery({
    ...AuthQueryOptions['get:/wello/v2/auth/recommend-policy']({
      query: { recommendPolicySort: 'PRIORITY', recommendViewType: 'LIST' },
    }),
  });

  const { data: pointData } = useSuspenseQuery({
    ...AuthQueryOptions['get:/wello/v2/auth/point'](),
  });

  const availableCount = policyData?.context?.availableCount ?? 0;
  const totalPoints = pointData?.context?.totalPoints ?? 0;

  return (
    <section className="px-20 pb-4">
      <div className="flex gap-8">
        <Card
          href={ROUTES.RECOMMEND_POLICY_LIST.pathname}
          label="맞춤정책"
          count={`${availableCount}건`}
          badge={
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="16" height="16" rx="8" fill="#FF7A14" />
              <path
                d="M10.8978 11.5359H9.62707L6.51934 7.04353H6.46754V11.5359H5V4.46411H6.29144L9.375 8.95306H9.43715V4.46411H10.8978V11.5359Z"
                fill="white"
              />
            </svg>
          }
        />
        <Card
          href={ROUTES.POINTS.pathname}
          label="웰포인트"
          count={
            <>
              {totalPoints.toLocaleString()}
              <span className="text-B-500">P</span>
            </>
          }
        />
      </div>
    </section>
  );
};
